import axios from "axios";
import store from '../../redux/store';
import AppConsts from "../../appconst";
import * as actions from "./SettingsTypes";
import { UserLogout } from '../Login/LoginActions';
import { Modal } from 'antd';

var logout = false;

export const getSourceList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getSourceList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETSOURCELIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveSource = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveSource",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteSource = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteSource",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getStageList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getStageList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETSTAGELIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveStage = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveStage",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteStage = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteStage",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getVerticalList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getVerticalList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETVERTICALLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveVertical = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveVertical",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteVertical = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteVertical",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getStatusList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETSTATUSLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTaskStatusList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTaskStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTASKSTATUSLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveTaskStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTaskStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTaskStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTaskStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getUserRoleList = async (data) => {
    try {
        const apiResonse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetUserRoles",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERROLESLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResonse;
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getRoleAuthorizationList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getRoleAuthorization",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETROLEAUTHORIZATIONLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveRoleAuthorization = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveRoleAuthorization",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const copyRoleAuthorization = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/CopyRoleAuthorization",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const saveRole = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveRole",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const assignRole = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/AssignRole",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getAuthorizedPages = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAuthorizedPages",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETAUTHORIZEDPAGES, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getUserList = async (data) => {
    try {
        const apiResonse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetUserList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResonse;
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getAdvanceSeriesList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAdvanceSeriesList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETADVANCESERIESLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getAdvanceSetting = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAdvanceSetting",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETADVANCESETTING, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const saveAdvanceSetting = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveAdvanceSetting",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getAccountList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAccountList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETACCOUNTLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

// Support Desk
// project
export const getProjectTypeList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetProjectTypeList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETPROJECTTYPELIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveProjectType = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveProjectType",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteProjectType = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteProjectType",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getProjectStatusList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetProjectStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETPROJECTSTATUSLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveProjectStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveProjectStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteProjectStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteProjectStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const fetchEmbedToken = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: "https://api.powerbi.com/v1.0/myorg/GenerateToken",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

//SupportDesk
// Ticket
export const getTicketLevelList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTicketLevelList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETLEVELLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveTicketLevel = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTicketLevel",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTicketLevel = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketLevel",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTicketPriorityList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTicketPriorityList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETPRIORITYLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveTicketPriority = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTicketPriority",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTicketPriority = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketPriority",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTicketStatusList = async (data) => {
    try {
        const apiResonse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTicketStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SETTICKETSTATUSLIST, payload: { list: response.data } });
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                };
            };
            console.log({ content: err.message });
        });

        return apiResonse;
    }
    catch (err) {
        console.log({ content: err.message });

    };
};

export const saveTicketStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTicketStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTicketStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getDepartmentList = async (data) => {
    try {
        const apiResonse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetDepartmentList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETDEPARTMENTLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResonse;
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveDepartment = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveDepartment",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getDeparmentForEdit = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetDepartmentForEdit",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETDEPARTMENTDETAIL, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const deleteDepartment = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteDepartment",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteIssueType = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteIssueType",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getNotificationList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTktNotify",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETNOTIFICATIONLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const updateNotification = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/UpdateTktNotify",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getHistoryList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTktHistory",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETHISTORYLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const updateHistory = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/UpdateTktHistory",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTktReview = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTktReview",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETREVIEWLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const updateTktReview = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/updateTktReview",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getDivisionAdminAccessList = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetDivisionAdminAccessByUser",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SET_DIVISION_ADMIN_ACCESS_LIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const getUserData = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetUserById",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SET_USER_DATA, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const updateUser = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/UpdateUser",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                };
            };
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const getDivisionList = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetDivisionList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SET_DIVISION_LIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const saveDivisionAdminAccess = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveDivisionAdminAccess",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                };
            };
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const getUserEmailList = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getUserEmails",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SET_USER_EMAIL_LIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const getTimeZonesList = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAllTimeZonesList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SET_TIME_ZONES_LIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const getRootCauseList = async (data) => {
    try {
        const result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetRootCauseList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SET_ROOT_CAUSE_LIST, payload: { list: response.data } });
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const saveRootCauseList = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveRootCauseList",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const deleteRootCause = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteRootCause",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

// Skills API Actions
export const getSkillsList = async (data) => {
    try {
        const result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Goals/GetSkillsList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SET_SKILLS_LIST, payload: { list: response.data } });
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const saveOrUpdateSkill = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Goals/SaveOrUpdateSkill",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const deleteSkill = async (data) => {
    try {
        const result = axios({
            method: 'delete',
            url: AppConsts.apiBaseUrl + "/Goals/DeleteSkill",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

// Organization Level API Actions
export const getOrganisationLevelsList = async (data) => {
    try {
        const result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Goals/GetOrganisationLevelsList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SET_ORGANISATION_LEVELS_LIST, payload: { list: response.data } });
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const saveOrUpdateOrganisationLevel = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Goals/SaveOrUpdateOrganisationLevel",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const deleteOrganisationLevel = async (data) => {
    try {
        const result = axios({
            method: 'delete',
            url: AppConsts.apiBaseUrl + "/Goals/DeleteOrganisationLevel",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const getUserDepartmentsList = async (data) => {
    try {
        const result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Goals/GetUserDepartmentsList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SET_USER_DEPARTMENTS_LIST, payload: { list: response.data } });
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const saveOrUpdateUserDepartment = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Goals/SaveOrUpdateUserDepartment",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const deleteUserDepartment = async (data) => {
    try {
        const result = axios({
            method: 'delete',
            url: AppConsts.apiBaseUrl + "/Goals/DeleteUserDepartment",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    };
};

export const getClustersList = async (data) => {
    try {
        const result = await axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Cluster/GetActiveClusters",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        });

        const clustersData = result.data.data || [];
        store.dispatch({ type: actions.SET_CLUSTERS_LIST, payload: { list: clustersData } });
        return clustersData;
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const saveOrUpdateCluster = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Cluster/SaveCluster",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteCluster = async (data) => {
    try {
        const result = axios({
            method: 'delete',
            url: AppConsts.apiBaseUrl + "/Cluster/DeleteCluster",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                }
            }
            console.log({ content: err.message });
            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getLeaveWFHMasterList = async (data) => {
    try {
        const result = await axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Cluster/GetAllLeaveWFHMaster",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        });

        const leaveWFHMasterData = result.data.data || [];
        store.dispatch({ type: actions.SET_LEAVE_WFH_MASTER_LIST, payload: { list: leaveWFHMasterData } });
        return leaveWFHMasterData;
    }
    catch (err) {
        if (err?.response?.status == 401) {
            if (!logout) {
                logout = true;
                Modal.confirm({
                    content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                    onOk: () => { UserLogout(); }
                });
            }
        }
        console.log({ content: err.message });
        return [];
    }
};

export const saveOrUpdateLeaveWFHMaster = async (data) => {
    try {
        const result = await axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Cluster/SaveLeaveWFHMaster",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        });

        return result.data;
    }
    catch (err) {
        if (err?.response?.status == 401) {
            if (!logout) {
                logout = true;
                Modal.confirm({
                    content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                    onOk: () => { UserLogout(); }
                });
            }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteLeaveWFHMaster = async (data) => {
    try {
        const result = await axios({
            method: 'delete',
            url: AppConsts.apiBaseUrl + "/Cluster/DeleteLeaveWFHMaster",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        });

        return result.data;
    }
    catch (err) {
        if (err?.response?.status == 401) {
            if (!logout) {
                logout = true;
                Modal.confirm({
                    content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                    onOk: () => { UserLogout(); }
                });
            }
        }
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

